import { render, staticRenderFns } from "./loadtxt.vue?vue&type=template&id=74aa8a4e&scoped=true&"
import script from "./loadtxt.vue?vue&type=script&lang=js&"
export * from "./loadtxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa8a4e",
  null
  
)

export default component.exports